import { atom } from 'recoil';

const textSelectorState = atom({
    key: "textSelectorState",
    default: ""
  });
  export default textSelectorState;